var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "progressBox" }, [
    _c("div", { staticClass: "progressText" }, [
      _c("span", { staticClass: "percentageCompleted" }, [
        _vm._v(_vm._s(Math.floor(_vm.progressPercentage)) + "%"),
      ]),
    ]),
    _c("div", { staticClass: "progressBar" }, [
      _c(
        "div",
        {
          staticClass: "progressValue",
          style: { width: Math.floor(_vm.progressPercentage) + "%" },
        },
        [_vm._v(" ")]
      ),
    ]),
    _c("div", { staticClass: "progressStatus" }, [_vm._v(_vm._s(_vm.text))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }